import { render, staticRenderFns } from "./Office-New-Request-Step4.vue?vue&type=template&id=023ec279&scoped=true&"
import script from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
export * from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
import style0 from "./Office-New-Request-Step4.vue?vue&type=style&index=0&id=023ec279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ec279",
  null
  
)

export default component.exports